import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installAuthFetch } from './auth/authFetch';

// Enforce the dashboard SSO gate on every API call before the app mounts:
// send the g6_session cookie and redirect to sign-in on a 401 challenge.
installAuthFetch();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
    